var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light/Category"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Category"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7C3 4.37479 3.02811 3.5 6.5 3.5C9.97189 3.5 10 4.37479 10 7C10 9.62521 10.0111 10.5 6.5 10.5C2.98893 10.5 3 9.62521 3 7Z",
    stroke: "#656565",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7C14 4.37479 14.0281 3.5 17.5 3.5C20.9719 3.5 21 4.37479 21 7C21 9.62521 21.0111 10.5 17.5 10.5C13.9889 10.5 14 9.62521 14 7Z",
    stroke: "#656565",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 18C3 15.3748 3.02811 14.5 6.5 14.5C9.97189 14.5 10 15.3748 10 18C10 20.6252 10.0111 21.5 6.5 21.5C2.98893 21.5 3 20.6252 3 18Z",
    stroke: "#656565",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 18C14 15.3748 14.0281 14.5 17.5 14.5C20.9719 14.5 21 15.3748 21 18C21 20.6252 21.0111 21.5 17.5 21.5C13.9889 21.5 14 20.6252 14 18Z",
    stroke: "#656565",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsIcon);
export default __webpack_public_path__ + "static/media/projects-icon.09c01d7b7c33af9871892b0ebe479674.svg";
export { ForwardRef as ReactComponent };